import { useState } from 'react'
import { useApi } from '../hooks/useApi'
import {
  SummaryCards,
  TestEvolutionChart,
  StatusDistribution,
  RecentBuilds,
  BuildHistoryWarning,
} from '../components'
import { useTranslation } from '../i18n'
import type { DashboardSummary, EvolutionResponse } from '../types'

const TIME_RANGE_OPTIONS = [7, 30, 90, 180, 365] as const

export function Dashboard() {
  const { t } = useTranslation()
  const [days, setDays] = useState(30)
  const summary = useApi<DashboardSummary>('/dashboard/summary')
  const evolution = useApi<EvolutionResponse>(`/dashboard/evolution?days=${days}`)

  return (
    <div data-testid="dashboard-page">
      <div className="page-header">
        <div className="page-title-group">
          <h1 className="page-title">{t('page.dashboard')}</h1>
          <BuildHistoryWarning data={summary.data} loading={summary.loading} />
        </div>
        <div className="time-range">
          <label htmlFor="time-range-select">{t('label.timeRange')}</label>
          <select
            id="time-range-select"
            data-testid="time-range-select"
            className="input"
            value={days}
            onChange={(e) => setDays(Number(e.target.value))}
          >
            {TIME_RANGE_OPTIONS.map((option) => (
              <option key={option} value={option}>
                {t('label.lastNDays', { days: option })}
              </option>
            ))}
          </select>
        </div>
      </div>

      <SummaryCards data={summary.data} loading={summary.loading} />

      <div className="grid grid-cols-2">
        <TestEvolutionChart data={evolution.data} loading={evolution.loading} />
        <StatusDistribution data={summary.data} loading={summary.loading} />
      </div>

      <RecentBuilds data={evolution.data} loading={evolution.loading} />
    </div>
  )
}
